import axios from "axios";

import {
    webApiEtapasConcurso2025,
    webApiBasesConcurso2025,
    webApiPremiosConcurso2025,
    webApiTematica2025,
    webApiIntroduccion2025,
    webApiVideosConcurso2025,
    webApiIntegrantesConcurso2025
} from "../routes/endpoints";

/** GET requests*/

export const getEtapasConcursoData = async (anio:any) => {
    let formD= new FormData();
    formD.append('anio',anio)
    const res = await axios.post(webApiEtapasConcurso2025,formD);
    const { data } = res;
    return data;
};

export const getBasesConcursoData = async (anio:any) => {
    let formD= new FormData();
    formD.append('anio',anio)
    const res = await axios.post(webApiBasesConcurso2025,formD);
    const { data } = res;
    return data;
};

export const getPremiosConcursoData = async (anio:any) => {
    let formD= new FormData();
    formD.append('anio',anio)
    const res = await axios.post(webApiPremiosConcurso2025,formD);
    const { data } = res;
    return data;
};

export const getIntroduccionConcursoData = async (anio:any) => {
    let formD= new FormData();
    formD.append('anio',anio)
   let res =  await axios.post(webApiIntroduccion2025,formD)
   let  {data}  = res;
   return data;
}

export const getTematicasConcursoData = async (anio:any) => {
    let formD= new FormData();
    formD.append('anio',anio)
    const res = await axios.post(webApiTematica2025,formD);
    const { data } = res;
    return data;
};

export const getVideosData = async (anio:any) => {
    let formD= new FormData();
    formD.append('anio',anio)
    const res = await axios.post(webApiVideosConcurso2025,formD);
    const { data } = res;
    return data;
};


export const getIntegrantesData = async (anio:any) => {
    let formD= new FormData();
    formD.append('anio',anio)
    const res = await axios.post(webApiIntegrantesConcurso2025,formD);
    const { data } = res;
    return data;
};

